import React, { useEffect, useState } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import SearchIcon from "@mui/icons-material/Search";
import SaveIcon from "@mui/icons-material/Save";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { AiOutlineUserAdd } from "react-icons/ai";
import { AiOutlineFileAdd } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import {
	resetUpdateCurrencyMasterList,
	updateCurrencyMasterList
} from "../../redux/actions/updateCurrencyMasterListAction";

import {
	resetGetCurrencyMasterList,
	getCurrencyMasterList
} from "../../redux/actions/getCurrencyMasterListAction";

import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";

import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import BackButton from "../../components/BackButton/BackButton";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import SOLogout from "../../components/Logout/SOLogout";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const CurrencyMaster = () => {
	const [idDefault, setIdDefault] = useState("");
	const [currency, setCurrency] = useState("");
	const [notificationOpen, setNotificationOpen] = React.useState(false);
	const [getCurrencyMasterListStatus, setGetCurrencyMasterListStatus] =
		useState(false);
	const [getCurrencyMasterListArray, setGetCurrencyMasterListArray] = useState(
		[]
	);
	const [updateCurrencyMasterStatus, SetupdateCurrencyMasterStatus] =
		useState(false);

	const [updateCurrencyMasterArray, setUpdateCurrencyMasterArray] =
		useState("");

	const [isLoading, setIsLoading] = useState(false);

	const getCurrencyMasterListRes = useSelector(
		({ getCurrencyMasterList }) => getCurrencyMasterList
	);
	// console.log("getCurrencyMasterListRes", getCurrencyMasterListRes);

	const adminCurrencyList = useSelector(
		({ adminCurrencyList }) => adminCurrencyList
	);

	const classes = useStyles();

	const dispatch = useDispatch();
	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;

	const updateCurrencyMasterListRes = useSelector(
		({ updateCurrencyMasterList }) => updateCurrencyMasterList
	);

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};

	const handleChange = ({ target: { name, value } }) => {
		if (name === "currency") {
			// setCurrency(value);
			setCurrency(value == "Select Currency" ? "" : value);
		}
		if (name === "idDefault") {
			setIdDefault(value);
		}
	};
	let obj = getCurrencyMasterListArray;

	const getCurrIdx = (idx, value) => {
		obj[idx].isActive = value;
		// console.log(getCurrencyMasterListArray, "obj");
		setGetCurrencyMasterListArray([]);
		setGetCurrencyMasterListArray([].concat(obj));
	};

	const getCurrencyMasterListApi = () => {
		setIsLoading(true);
		setGetCurrencyMasterListStatus(true);
		const getCurrencyMasterListReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				currency: currency
			}
		};

		return dispatch(getCurrencyMasterList(getCurrencyMasterListReq, authToken));
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getCurrencyMasterListApi();
		}
	}, [regenerateTokenRes.data.status]);

	useEffect(() => {
		if (getCurrencyMasterListStatus) {
			if (getCurrencyMasterListRes.data.status == "success") {
				setIsLoading(false);
				setGetCurrencyMasterListArray(
					[].concat(
						getCurrencyMasterListRes.data.customerMasterDetailsRequestVOList
					)
				);
			}
			if (getCurrencyMasterListRes.data.status == "Failed") {
				setIsLoading(false);
				setGetCurrencyMasterListArray(getCurrencyMasterListRes.data);
				if (
					getCurrencyMasterListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getCurrencyMasterListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getCurrencyMasterListRes.data.status == "failed") {
				setIsLoading(false);
				setGetCurrencyMasterListArray(getCurrencyMasterListRes.data);
				if (
					getCurrencyMasterListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getCurrencyMasterListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getCurrencyMasterListRes.data.status == "NOT FOUND") {
				setIsLoading(false);
				setGetCurrencyMasterListArray(getCurrencyMasterListRes.data);
			}
		}
	}, [getCurrencyMasterListRes.data.status]);

	const updateCurrencyMasterListReq = () => {
		SetupdateCurrencyMasterStatus(true);
		const updateCurrencyMasterListApi = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			customerMasterDetailsRequestVOList: getCurrencyMasterListArray
		};

		return dispatch(
			updateCurrencyMasterList(updateCurrencyMasterListApi, authToken)
		);
	};

	useEffect(() => {
		if (updateCurrencyMasterStatus) {
			if (updateCurrencyMasterListRes.data.status == "success") {
				setNotificationOpen(true);
				setUpdateCurrencyMasterArray(updateCurrencyMasterListRes.data.status);
			}
			if (updateCurrencyMasterListRes.data.status == "Failed") {
				setNotificationOpen(true);
				setUpdateCurrencyMasterArray(updateCurrencyMasterListRes.data.status);
				if (
					updateCurrencyMasterListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					updateCurrencyMasterListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (updateCurrencyMasterListRes.data.status == "failed") {
				setNotificationOpen(true);
				setUpdateCurrencyMasterArray(updateCurrencyMasterListRes.data.status);
				if (
					updateCurrencyMasterListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					updateCurrencyMasterListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	}, [updateCurrencyMasterListRes.data.status]);

	return (
		<>
			<Layout>
				<Card>
					{/* <BackButton /> */}
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={12} md={6} lg={6}>
							<TextField
								select
								size="small"
								color="primary"
								// autoFocus={true}
								type="text"
								label="Currency"
								fullWidth={true}
								variant="standard"
								name="currency"
								// value={currency || "Select Currency"}
								defaultValue={"Select Currency" || currency}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="Select Currency" selected="Select Currency">
									Select Currency
								</MenuItem>
								{adminCurrencyList.success &&
									[]
										.concat(adminCurrencyList.data.currencyList)
										.map((x) => <MenuItem value={x}>{x}</MenuItem>)}
							</TextField>
						</Grid>

						<Grid item xs={12} sm={12} md={6} lg={6} container>
							<Grid>
								{/* <Button
                  style={{
                    backgroundColor: "#00b9f5",
                    color: "white",
                    marginTop: "7px",
                  }}
                  endIcon={<AiOutlineSearch />}
                  variant="contained"
                  onClick={getCurrencyMasterListApi}
                >
                  Search
                </Button> */}
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={getCurrencyMasterListApi}
								>
									Search <SearchIcon />
								</CustomButton>
							</Grid>
							<Grid item md={7}></Grid>
						</Grid>
					</Grid>
				</Card>
				{/* Data update successfully */}
				{isLoading ? (
					<LoadingSpinner />
				) : getCurrencyMasterListArray.length == undefined ||
					!getCurrencyMasterListStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Currency List
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
								// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Currency List
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table
									className={classes.table}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Currency{" "}
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Is Default
											</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										{getCurrencyMasterListArray &&
											[]
												.concat(getCurrencyMasterListArray)
												.map((row, index) => (
													<TableRow key={row.walletId}>
														<TableCell align="center">{row.currency}</TableCell>
														<TableCell align="center">
															{/* {row.isActive} */}
															<TextField
																select
																size="small"
																color="primary"
																autoFocus={true}
																variant="standard"

																type="text"
																value={
																	// row.isActive ? row.isActive : row[index].isActive
																	row.isActive
																}
																// value={row.isActive ? row.isActive : idDefault}
																name="idDefault"
																fullWidth={true}
																onChange={handleChange}
															// onClick={() => getCurrIdx(index)}
															// onChange={() => {
															//   handleChange(index);
															// }}
															>
																<MenuItem
																	// selected={row.isActive === "Y"}
																	value={"Y"}
																	onClick={() => getCurrIdx(index, "Y")}
																>
																	Y
																</MenuItem>
																<MenuItem
																	// selected={row.isActive === "N"}
																	value={"N"}
																	onClick={() => getCurrIdx(index, "N")}
																>
																	N
																</MenuItem>
															</TextField>
														</TableCell>
													</TableRow>
												))}

										<TableRow>
											<TableCell></TableCell>
											<TableCell align="center">
												<CustomButton
													style={{
														padding: "8px"
													}}
													onClick={updateCurrencyMasterListReq}
												>
													Save <SaveIcon />
												</CustomButton>
											</TableCell>
										</TableRow>
									</TableBody>
								</Table>
							</TableContainer>
						</Grid>
					</Card>
				)}
			</Layout>

			{updateCurrencyMasterArray.toLowerCase() == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h3
								className=""
								style={{
									margin: "0 20px",
									fontSize: "15px",
									textAlign: "center"
								}}
							>
								Data update successfully
							</h3>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							// endIcon={<SaveIcon />}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{updateCurrencyMasterArray.toLowerCase() == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h3
								className=""
								style={{
									margin: "0 20px",
									fontSize: "15px",
									textAlign: "center"
								}}
							>
								Data Not Updated
							</h3>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							// endIcon={<SaveIcon />}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{updateCurrencyMasterArray.toLowerCase() == "Failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h3
								style={{
									margin: "0 20px",
									fontSize: "15px",
									textAlign: "center"
								}}
								className=""
							>
								Data Not Updated
							</h3>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							// endIcon={<SaveIcon />}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default CurrencyMaster;
